import { InjectionToken } from '@angular/core';
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.prototype.get = function (key, fallback) {
        var c = getConfig();
        if (c) {
            return c.get(key, fallback);
        }
        return null;
    };
    Config.prototype.getBoolean = function (key, fallback) {
        var c = getConfig();
        if (c) {
            return c.getBoolean(key, fallback);
        }
        return false;
    };
    Config.prototype.getNumber = function (key, fallback) {
        var c = getConfig();
        if (c) {
            return c.getNumber(key, fallback);
        }
        return 0;
    };
    Config.prototype.set = function (key, value) {
        var c = getConfig();
        if (c) {
            c.set(key, value);
        }
    };
    return Config;
}());
export { Config };
export var ConfigToken = new InjectionToken('USERCONFIG');
function getConfig() {
    var win = window;
    if (typeof win !== 'undefined') {
        var Ionic = win.Ionic;
        if (Ionic && Ionic.config) {
            return Ionic.config;
        }
    }
    return null;
}
